import { createFileRoute } from "@tanstack/react-router";
import Dashboard from "@/pages/Dashboard";

export const Route = createFileRoute("/$leaid/_error-wrapper/")({
  component: Dashboard,
});
